import {useState, useRef, useMemo} from "react";
import {useSwipeable} from "react-swipeable";
import classNames from "classnames";
import {Picture} from "@/shared/ui/Picture";
import styles from "./ProductMediaSlider.module.scss";

type Props = {
    media: string[];
    alt: string;
    className?: string;
};

// media = [
//     'https://ir-3.ozone.ru/s3/multimedia-1-k/wc500/7372725464.jpg',
//     'https://ir-3.ozone.ru/s3/multimedia-1-i/wc500/7337178882.jpg',
//     'https://ir-3.ozone.ru/s3/multimedia-1-r/wc500/7372989819.jpg',
//     'https://ir-3.ozone.ru/s3/multimedia-1-q/wc500/7269154694.jpg',
//     'https://ir-3.ozone.ru/s3/multimedia-1-o/wc500/7425332088.jpg',
// ];

export const ProductMediaSlider = ({media, alt, className}: Props) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const videoRef = useRef<HTMLVideoElement | null>(null);

    const safeMedia = media?.length ? media : [];
    const current = safeMedia[activeIndex];

    const isVideo = useMemo(() => current?.endsWith(".mp4"), [current]);

    const changeMedia = (index: number) => {
        setActiveIndex(index);

        if (media[index]?.endsWith(".mp4") && videoRef.current) {
            videoRef.current.load(); // Обновляем видео
        }
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => setActiveIndex((prev) => (prev + 1) % safeMedia.length),
        onSwipedRight: () => setActiveIndex((prev) => (prev - 1 + safeMedia.length) % safeMedia.length),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    if (!safeMedia.length) return null;

    return (
        <div {...handlers} className={classNames(styles.root, className)} onMouseLeave={() => setActiveIndex(0)}>
            {isVideo ? (
                <video
                    ref={videoRef}
                    playsInline
                    src={current}
                    className={styles.video}
                    autoPlay
                    loop
                    muted
                />
            ) : (
                <Picture
                    src={current}
                    alt={alt}
                    width={290}
                    height={290}
                    loading={`eager`}
                    fetchPriority={`high`}
                    classes={{image: styles.image}}
                />
            )}
            <div className={styles.hoverZones}>
                {safeMedia.map((_, index) => (
                    <div
                        key={index}
                        className={styles.zone}
                        onMouseEnter={() => changeMedia(index)}
                    />
                ))}
            </div>
            <div className={styles.dots}>
                {safeMedia.map((_, index) => (
                    <div
                        key={index}
                        className={classNames(styles.dot, {
                            [styles.active]: index === activeIndex,
                        })}
                    />
                ))}
            </div>
        </div>
    );
}
